/** The Care Team's line, as dialled and as printed. One place, so the two never drift apart. */
export const SUPPORT_PHONE_NUMBER = '+18339292559'
export const SUPPORT_PHONE_DISPLAY = '833-929-2559'
